import React from 'react';
import Slider from 'react-slick';
import { Box, Button, Card, Divider, Stack, Typography } from '@mui/joy';
import { useThemeContext } from '../../context/ThemeContext';
import FundiBidCard from '../card/fundi/FundiBidCard';

const prevArrowImg = 'assets/images/icons/Group 19775.png';
const nextArrowImg = 'assets/images/icons/Group 19774.png';

function SliderExploreJob() {

  const { isSM, isMd, isMD, isLg } = useThemeContext()

  const settings = {
    dots:false,
    infinite: false,
    centerMode: false, 
    slidesToShow: 2.5, 
    slidesToScroll: 2, 
    speed: 1000,
    arrows: true,
    prevArrow: (
      <div className="custom-prev-arrow">
        <img width={40} height={40} src={prevArrowImg} alt="Previous" />
      </div>
    ),
    nextArrow: (
      <div className="custom-next-arrow">
        <img width={40} height={40} src={nextArrowImg} alt="Next" />
      </div>
    ),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2.5, 
    slidesToScroll: 2, 
        },
      },
      {
        breakpoint: 768,
        settings: {
         slidesToShow: 2.5, 
    slidesToScroll: 2, 
        },
      },
    ],
  };

  const jobs = [
    {
      title: "Marketing Leads Finding",
      user: "Austin",
      location: "City Name, Country Name",
      time: "3 days ago",
      
    },
    {
      title: "Cleaning Process Checklist",
      user: "Joy",
      location: "City Name, Country Name",
      time: "5 days ago",
      
    },
    {
      title: "Carpentry Furniture Service",
      user: "Thomas",
      location: "City Name, Country Name",
      time: "2 days ago",
      
    },
    {
      title: "IT Support Specialist",
      user: "Emma",
      location: "City Name, Country Name",
      time: "1 day ago",
      
    },
  ];

  return (
    <Box sx={{width: isSM ? '100%' : isMD ? '100%' : isMd ? '1207px' : '1207px', margin: "auto", padding: "10px 0" }}>
      <Typography variant="h4" align="left" gutterBottom>
        Explore New Job
      </Typography>
      <Slider {...settings}>
        {jobs.map((job, index) => (
          <div key={index} style={{ padding: "0 15px", boxSizing: "border-box" }}>
            <Card variant="outlined" sx={{ width: isSM ? '100%' : isMD ? '98%' : isMd ? '470px' : '470px', backgroundColor: 'transparent', boxSizing: "border-box",p:2 }}>
              <Stack
                direction="row"
                sx={{ justifyContent: 'space-between', alignItems: 'left' }}
              >
                <Box>
                  <Typography gutterBottom variant="h5" component="div">
                    Job -
                  </Typography>
                  <Typography level='body-xs' sx={{ textAlign: 'center' }}>Plumbing (Leak Fixing)</Typography>
                </Box>
                <Box>
                  <Typography gutterBottom variant="h5" component="div">
                    Date & Time -
                  </Typography>
                  <Typography level='body-xs' sx={{ textAlign: 'left' }}>12/01/2025 & Evening 2 to 7</Typography>
                </Box>
              </Stack>
              <Divider inset="none" sx={{ height: '2px', backgroundColor: '#03fc0b' }} />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 4 }}>
                  <FundiBidCard />
                  <Box>
                    <Typography gutterBottom variant="h5" component="div">
                      Kalvin
                    </Typography>
                    <Typography level='body-xs' sx={{ textAlign: 'left' }}>City Name, country Name</Typography>
                  </Box>
                </Box>
                <Button
                  sx={{
                    padding: "5px 30px 5px",
                    maxWidth: "100%",
                    textAlign: "center",
                    backgroundColor: "#28A745",
                    "&:hover": {
                      backgroundColor: "#28A745",
                      color: "#ffffff",
                      boxShadow: 3,
                    },
                  }}
                >
                  Post a Bid
                </Button>
              </Box>
            </Card>
          </div>
        ))}
      </Slider>
    </Box>
  );
}

export default SliderExploreJob;
